let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dYk9q")).then(() => parcelRequire('29nf6'));